import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { gsap } from 'gsap';
import ResponsiveSwiper from './ResponsiveSwiper';

gsap.registerPlugin(ScrollTrigger);

class AnchorLinks {
  constructor(el, wWidth) {
    this.$block = $(el);
    this.$links = this.$block.find('a');
    this.wWidth = wWidth;
    this.responsiveBreakpoint = 768;

    this.swiper = null;
    this.sticky = null;
    this.observer = null;
    this.sections = [];

    this.init();
  }

  init() {
    this.mm = gsap.matchMedia();

    // swiper
    this.swiper = new ResponsiveSwiper(
      this.$block[0],
      this.wWidth,
      {
        slidesPerView: 'auto',
        speed: 500,
        centeredSlides: true,
      },
      this.responsiveBreakpoint
    );

    // auto scroll swiper to active slide
    this.mm.add('(max-width: 768px)', () => {
      this.$links.each((i, el) => {
        const { hash } = el;
        const $block = $(hash);
        if (!$block.length) return;

        const section = ScrollTrigger.create({
          trigger: $block.get(0),
          start: 'top center',
          end: 'bottom center',
          onToggle: ({ isActive }) => {
            if (!isActive) return;
            this.swiper.instance.slideTo(i);
          },
        });

        this.sections.push(section);
      });
    });
  }

  onResize(wWidth) {
    this.wWidth = wWidth;
    this.swiper.onResize(wWidth);
  }
}

export default AnchorLinks;
